import { Activity, Boxes, Brain, ClipboardCheck, Moon, Package, Receipt, ShieldCheck, Unlock, Users } from "lucide-react";

import Eyebrow from "../../Eyebrow";
import Reveal from "../../Reveal";
import SpotlightCard from "../../SpotlightCard";
import TechNote from "../TechNote";
import { howItWorksSections } from "../../../../content/howItWorksSections";

const icons = { ClipboardCheck, Boxes, ShieldCheck, Activity, Unlock, Moon, Brain, Package, Receipt, Users };

/**
 * Two grouped lists of "why they pick us" reasons, split by organization
 * size (hospital system / health network vs. independent practice).
 * Translation: Two grouped lists of "why they pick us" reasons, split by organization
 * size (hospital system / health network vs. independent practice).
 *
 * @returns {JSX.Element} Audience-fit section.
 */
const AudienceFit = () => {
  const { audienceFit, techNotes } = howItWorksSections;

  return (
    <section id="audience-fit" className="section-block">
      <div className="section-shell">
        <Reveal>
          <Eyebrow>
            {audienceFit.eyebrowLabel}
            <TechNote>{techNotes[audienceFit.techNote]}</TechNote>
          </Eyebrow>
          <h2 className="section-heading__title">{audienceFit.title}</h2>
          <p className="section-heading__intro">{audienceFit.description}</p>
        </Reveal>

        <div className="hiw-audience-grid">
          {audienceFit.groups.map((group) => (
            <div className="hiw-audience-col" key={group.id}>
              <h3 className="hiw-audience-col__label">{group.label}</h3>
              <div className="hiw-trust-list hiw-trust-list--single">
                {group.items.map((item, index) => {
                  const Icon = icons[item.icon];

                  return (
                    <Reveal key={item.title} delay={index * 60}>
                      <SpotlightCard className="glass-panel hiw-trust-item">
                        <Icon className="hiw-trust-item__icon" strokeWidth={1} />
                        <div>
                          <strong>{item.title}</strong>
                          <p>{item.description}</p>
                        </div>
                      </SpotlightCard>
                    </Reveal>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AudienceFit;
